import React from 'react';
import dayjs from 'dayjs';
import { setColumnSort } from '../../../libs/utils';
//----------------------------------------------------------------------------------------------------
const LectureColumns = (props) => {
  const {
    sorts,
    setSorts,
    loading,
    setLoading,
    OnCellClick,
    OnDeleteCellClick,
    ...rests
  } = props;

  return [
    {
      // title: '센터명',
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'lecture_title'));
            }}
            style={{ ...styles.col_headers }}
          >
            {`강의명`}
          </div>
        );
      },
      sorter: true,
      width: 300,
      dataIndex: 'lecture_title',
      key: 'lecture_title',
      render: (value, obj) => {
        return (
          <div
            style={{ ...styles.col_text }}
            onClick={(e) => {
              OnCellClick({ id: obj.lecture_id });
            }}
          >
            {value}
          </div>
        );
      },
      // fixed: 'left',
      /* sorter: (a, b) => {
        return a.age - b.age;
       },
      */
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'sequence_count'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'시퀀스 수'}
          </div>
        );
      },
      width: 100,
      dataIndex: 'sequence_count',
      key: 'sequence_count',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.lecture_id });
          }}
        >
          {value}
        </div>
      ),
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'tempo_count'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'템포 수'}
          </div>
        );
      },
      width: 100,
      dataIndex: 'tempo_count',
      key: 'tempo_count',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.lecture_id });
          }}
        >
          {value}
        </div>
      ),
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'creator_name'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'생성자'}
          </div>
        );
      },
      width: 150,
      dataIndex: 'creator_name',
      key: 'creator_name',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.lecture_id });
          }}
        >
          {value}
        </div>
      ),
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'total_time'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'총 시간'}
          </div>
        );
      },
      width: 90,
      dataIndex: 'total_time',
      key: 'total_time',
      sorter: true,
      render: (value, obj) => {
        return (
          <div
            style={{ ...styles.col_text }}
            onClick={(e) => {
              OnCellClick({ id: obj.lecture_id });
            }}
          >
            {value || '-'}
          </div>
        );
      },
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'created_at'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'생성일'}
          </div>
        );
      },
      width: 105,
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.lecture_id });
          }}
        >
          {(value && dayjs(value).format('YYYY.MM.DD')) || '-'}
        </div>
      ),
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'is_public'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'공유여부'}
          </div>
        );
      },
      width: 110,
      dataIndex: 'is_public',
      key: 'is_public',
      sorter: true,
      render: (value, obj) => {
        let planStyles = { ...styles.col_plan };

        if (value != 'T') {
          planStyles = {
            ...planStyles,
            background: 'rgba(168, 170, 174, 0.16)',
            color: '#A8AAAE',
          };
        } else if (value == '다운') {
          planStyles = {
            ...planStyles,
            background: 'rgba(115, 103, 240, 0.16)',
            color: '#7367F0',
          };
        }

        return (
          <div
            style={{ ...planStyles }}
            onClick={(e) => {
              OnCellClick({ id: obj.lecture_id });
            }}
          >
            {value}
          </div>
        );
      },
    },
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'updated_at'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'공유일'}
          </div>
        );
      },
      width: 90,
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.lecture_id });
          }}
        >
          {(obj.is_public != 'T'
            ? value
            : value && dayjs(value).format('YYYY.MM.DD')) || '-'}
        </div>
      ),
    },
    {
      // more
      title: (
        <div
          style={{
            display: 'flex',
            width: '3rem',
            flexDirection: 'column',
            justifyContetn: 'center',
            alignItems: 'center',
          }}
        >
          {`삭제`}
        </div>
      ),
      width: 30,
      // height: 48,
      render: (value, obj) => {
        return (
          <img
            width={22}
            height={22}
            src={require('../../../assets/images/ico_trash.png')}
            onClick={() => {
              OnDeleteCellClick({ id: obj.lecture_id });
            }}
          />
        );
      },
      fixed: 'right',
    },
  ];
};

//----------------------------------------------------------------------------------------------------
const styles = {
  col_headers: {
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  col1: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  col1_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_plan: {
    display: 'flex',
    width: '9.6rem',
    height: '2.4rem',
    wordWrap: true,
    gap: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 10px',
    background: 'rgba(40, 199, 111, 0.16)',
    borderRadius: 4,
    color: '#28C76F',
  },
};

export default LectureColumns;
/*
      display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 13px 0px;
gap: 4px;

width: 52px;
height: 48px;



flex: none;
order: 8;
flex-grow: 0;
*/
